import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { APPROVALS } from "@/data/mock";
import type { ApprovalItem } from "@/types";
import { withLatency } from "./simulate";

export async function fetchApprovals() {
  return withLatency([...APPROVALS]);
}

export async function updateApprovalStatus(id: string, status: ApprovalItem["status"]) {
  const index = APPROVALS.findIndex((a) => a.id === id);
  if (index !== -1) {
    APPROVALS[index] = { ...APPROVALS[index], status };
  }
  return withLatency(index !== -1 ? APPROVALS[index] : undefined, 220);
}

export function useApprovals() {
  return useQuery({ queryKey: ["approvals"], queryFn: fetchApprovals, staleTime: 30_000 });
}

export function useUpdateApprovalStatus() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, status }: { id: string; status: ApprovalItem["status"] }) => updateApprovalStatus(id, status),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["approvals"] }),
  });
}
